import { Node, mergeAttributes } from "@tiptap/core";
import { READ_MORE_ATTR } from "@/lib/read-more";

/**
 * Nœud « Lire plus » : un séparateur atomique qui marque la coupure entre la
 * partie visible d'une remarque publique et la suite révélée par « Lire plus »
 * sur le front / la prévisu (équivalent du `<!--more-->` de WordPress).
 *
 * Sérialisé en `<div data-read-more="true" class="read-more-tag"></div>` (voir
 * `READ_MORE_HTML`). Dans l'éditeur, il est rendu via un NodeView comme une
 * ligne pointillée libellée « Lire plus » — ce libellé n'apparaît PAS dans le
 * HTML de sortie (seul `renderHTML` définit la sérialisation).
 */
export const ReadMore = Node.create({
  name: "readMore",
  group: "block",
  atom: true,
  selectable: true,
  draggable: false,

  parseHTML() {
    return [{ tag: `div[${READ_MORE_ATTR}]` }, { tag: `hr[${READ_MORE_ATTR}]` }];
  },

  renderHTML() {
    return [
      "div",
      mergeAttributes({ [READ_MORE_ATTR]: "true", class: "read-more-tag" }),
    ];
  },

  addNodeView() {
    return () => {
      const dom = document.createElement("div");
      dom.setAttribute(READ_MORE_ATTR, "true");
      dom.className = "read-more-tag";
      dom.setAttribute("contenteditable", "false");
      dom.style.cssText =
        "display:flex;align-items:center;gap:8px;margin:10px 0;color:#64748b;" +
        "font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:0.06em;" +
        "user-select:none;cursor:default;";
      dom.innerHTML =
        '<span style="flex:1;border-top:1px dashed #94a3b8"></span>' +
        "<span>Lire plus</span>" +
        '<span style="flex:1;border-top:1px dashed #94a3b8"></span>';
      return { dom };
    };
  },
});

export default ReadMore;
